import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row animated fadeIn" }
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card border-left-primary shadow mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-between" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, "Deposits")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PendingDeposits = _resolveComponent("PendingDeposits")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_DepositsMissingValues = _resolveComponent("DepositsMissingValues")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_TabView, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_TabPanel, { header: "Pending" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PendingDeposits)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_TabPanel, { header: "Missing Values" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DepositsMissingValues)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}